'use client';

import React from 'react';
import Link from 'next/link';

export default function CCPALink() {
  return (
    <Link href="/privacy-policy#do-not-sell">
      <span className="text-xs inline-flex items-center gap-1 group transition-colors" style={{ color: 'oklch(65% .01 265)' }}>
        Do Not Sell My Personal Information
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-0 -translate-y-0.5 group-hover:opacity-100 group-hover:translate-y-0 transition-all">
          <path d="M7 7h10v10"></path>
          <path d="M7 17 17 7"></path>
        </svg>
      </span>
    </Link>
  );
}
